import { DiscordSDK } from '@discord/embedded-app-sdk';

const clientId = (import.meta.env.VITE_DISCORD_CLIENT_ID || '').trim();
export function isDiscordActivityEnvironment() {
  return window.location.hostname.endsWith('.discordsays.com') || window.parent !== window;
}

function timeout(promise, ms) {
  return Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error('Discord SDK zaman aşımı')), ms)),
  ]);
}

export async function initializeDiscord() {
  if (!isDiscordActivityEnvironment()) {
    return {
      mode: 'blocked',
      sdk: null,
      instanceId: '',
      user: null,
      participants: [],
      notice: 'AniTilky Watch Party yalnızca Discord Activity olarak açılır.',
    };
  }

  const params = new URLSearchParams(window.location.search);
  const activityInstanceId = params.get('instance_id') || params.get('instanceId') || '';
  if (/^i-[a-zA-Z0-9-]+$/.test(activityInstanceId)) {
    return {
      mode: 'discord',
      sdk: null,
      instanceId: activityInstanceId,
      user: null,
      participants: [],
      notice: '',
    };
  }

  if (!clientId) {
    return {
      mode: 'blocked',
      sdk: null,
      instanceId: '',
      user: null,
      participants: [],
      notice: 'Discord Activity yapılandırması eksik.',
    };
  }

  const sdk = new DiscordSDK(clientId, { disableConsoleLogOverride: true });
  try {
    await timeout(sdk.ready(), 5000);
    return {
      mode: 'discord',
      sdk,
      instanceId: sdk.instanceId,
      user: null,
      participants: [],
      notice: '',
    };
  } catch (error) {
    console.warn('Discord Activity başlatılamadı:', error.message);
    return {
      mode: 'blocked',
      sdk: null,
      instanceId: '',
      user: null,
      participants: [],
      notice: 'Discord Activity bağlantısı kurulamadı.',
    };
  }
}


export function closeActivity(sdk) {
  if (sdk) sdk.close(1000, 'Watch Party kapatıldı');
}
